export default "__VITE_ASSET__DCsqfqF1__"